export type KeysOfType<T extends Record<string, unknown>, ValueType> = {
  [K in keyof T]: T[K] extends ValueType ? K : never;
}[keyof T];

export type OmitFunctions<T> = {
  [K in keyof T as T[K] extends (...args: any[]) => any ? never : K]: T[K];
};

export type DeeplyRequired<T extends object> = {
  [K in keyof T]-?: T[K] extends object ? DeeplyRequired<T[K]> : Required<T[K]>;
};

export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

export function isDefined<T>(v: T | undefined | null): v is T {
  return v !== null && v !== undefined;
}
